<template>
  <select :id="id" v-model="selectedId" class="form-control">
    <option v-if="allowAll" value="">{{ allLabel }}</option>
    <option v-else value="" disabled>Initials</option>
    <option v-for="member in teamMembers" :key="member.id" :value="member.id">{{ member.initials }}</option>
  </select>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: {
    id: {
      type: String,
      default: 'teamMemberSelect',
    },
    value: {
      type: String,
      default: '',
    },
    allowAll: {
      type: Boolean,
      default: false,
    },
    allLabel: {
      type: String,
      default: 'All team members',
    },
  },
  data() {
    return {
      teamMembers: [],
    }
  },
  computed: {
    ...mapGetters(['custom_claims']),
    customerId() {
      return this.custom_claims?.customerId || null
    },
    selectedId: {
      get() {
        return this.value
      },
      set(teamMemberId) {
        const member = this.teamMembers.find((member) => member.id === teamMemberId) || null
        this.$emit('input', teamMemberId)
        this.$emit('member-selected', member)
      },
    },
  },
  watch: {
    customerId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadTeamMembers()
      }
    },
  },
  methods: {
    async loadTeamMembers() {
      if (!this.customerId) {
        this.teamMembers = []
        return
      }

      try {
        const snapshot = await Vue.firestore
          .collection('customers')
          .doc(this.customerId)
          .collection('users')
          .get()

        this.teamMembers = snapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((member) => !member.hidden && member.initials && member.initials.trim())
          .sort((left, right) => (left.initials || '').localeCompare(right.initials || ''))
      } catch (err) {
        console.error('Failed to load team members:', err)
      }
    },
  },
  mounted() {
    this.loadTeamMembers()
  },
}
</script>
